import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import NR_DETAILS from "../data/nrDetails.json";

export function NRModal({ nrId, onClose }) {
  const nr = NR_DETAILS[nrId];
  if (!nr) return null;

  return (
    <Dialog open={true} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <div className="font-mono text-[9px] uppercase tracking-[0.18em] text-muted-foreground mb-1">norma regulamentadora</div>
          <DialogTitle className="font-display text-3xl font-bold text-destructive tracking-tight">{nrId}</DialogTitle>
          <div className="text-sm text-foreground mt-1">{nr.titulo}</div>
        </DialogHeader>
        <div className="overflow-y-auto max-h-[60vh] pr-2">
          <div className="text-[11px] text-muted-foreground mb-3 leading-relaxed">
            <strong className="text-foreground font-semibold">Aplicação:</strong> {nr.aplicacao} ·{" "}
            <strong className="text-foreground font-semibold">ISO:</strong> {nr.iso}
          </div>
          <div className="font-mono text-[9px] font-bold text-destructive uppercase tracking-[0.18em] mb-2">itens-chave para auditoria</div>
          {nr.itens.map((it, i) => (
            <div key={i} className="px-3.5 py-2.5 bg-background rounded-md mb-1.5 border border-border border-l-4 border-l-destructive">
              <span className="font-mono text-[11px] font-semibold text-destructive mr-2.5">{it.item}</span>
              <span className="text-[12px] text-foreground leading-snug">{it.desc}</span>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
